import { api } from '../../client';

export interface EmployeeProjectDto {
  id: string;
  project_name: string;
}

export const employeeProjectsApi = {
  /**
   * List projects where the authenticated employee is on the team (team composition).
   */
  async list(): Promise<{ data?: EmployeeProjectDto[]; message?: string }> {
    return api.get('/employee/projects') as Promise<{ data: EmployeeProjectDto[] }>;
  },
};
